export const JOB_STATUS = {
  DONE: 'done',
  IN_PROGRESS: 'in_progress',
  ERROR: 'error',
};

export const IMPORT_ENTITIES = [
  'properties',
  'developments',
  'contacts',
  'owners',
];
// `developments` is kept for API validation and dashboard labels; the new-import
// wizard does not offer a developments entry in TBR-6074.

export const SPREADSHEET_STEPS = {
  ORIGIN: 1,
  UPLOAD: 2,
  MAPPING: 3,
  LEAD_STATUS: 4,
  AGENTS: 5,
  SETTINGS: 6,
  PROGRESS: 7,
};

// Backward-compatible alias — contacts and owners share this step map.
export const CONTACTS_STEPS = SPREADSHEET_STEPS;

// Placeholder until the help center article for exporting a CRM backup exists.
export const CRM_HELP_URL = '#';

export const STATUS_FILTER = {
  ALL: 'all',
  ...JOB_STATUS,
};

export const buildJobsFilter = (statusFilter) =>
  statusFilter && statusFilter !== STATUS_FILTER.ALL
    ? `&status=${statusFilter}`
    : '';
